"use client";

import { useRouter } from "next/navigation";
import Fragments from "@/components/fragments";
import Layouts from "@/components/layouts";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import { BsPerson } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";
import { TbDeviceImac } from "react-icons/tb";
import { FaMagnifyingGlass } from "react-icons/fa6";

const HomeVisitSchema = z.object({
  name: z.string(),
  devices: z.string(),
  email: z.string().email(),
  problem: z.string(),
});

const ContactForm = () => {
  const router = useRouter();
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<z.infer<typeof HomeVisitSchema>>({
    resolver: zodResolver(HomeVisitSchema),
  });
  const fields = [
    {
      name: "name",
      label: "Name",
      type: "text",
      icon: <BsPerson />,
      placeholder: "Masukkan Nama",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      icon: <AiOutlineMail />,
      placeholder: "Masukkan Email",
    },
    {
      name: "devices",
      label: "Jenis Perangkat",
      type: "select",
      icon: <TbDeviceImac />,
      options: [
        { value: "macbook", label: "MacBook" },
        { value: "macbookAir", label: "MacBook Air" },
        { value: "macbookPro", label: "MacBook Pro" },
        { value: "imac", label: "iMac" },
        { value: "macmini", label: "Mac-Mini" },
        { value: "macpro", label: "Mac-Pro" },
      ],
      placeholder: "Masukkan Devices",
    },
    {
      name: "problem",
      label: "Problem",
      type: "textarea",
      icon: <FaMagnifyingGlass />,
      placeholder: "Masukkan Permasalahan Pada Device Kamu",
    },
  ];

  const onSubmit = (data: any) => {
    router.push("https://wa.me/628165454883");
  };

  return (
    <Layouts.Form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid lg:grid-cols-12 lg:gap-6">
        {fields.map((field, index) => (
          <div
            key={index}
            className={`${
              field.type !== "textarea" && field.type !== "select"
                ? "lg:col-span-6"
                : "lg:col-span-12"
            } mb-5`}
          >
            <Fragments.Controller
              key={field.name}
              {...field}
              control={control}
              errors={errors}
              type={field.type}
            />
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-12">
        <div className="col-span-12">
          <Button className="w-full" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Layouts.Form>
  );
};

export default ContactForm;
